// Formato visible de nombres de lista/grupo: oculta la barra baja y
// capitaliza cada palabra. Aplica acentos en sectores conocidos.
// Ejemplos:
//   "estetica_ontinyent"   -> "Estética Ontinyent"
//   "peluquerias_canals"   -> "Peluquerías Canals"
//   "lavaderos_ontinyent"  -> "Lavaderos Ontinyent"

const ACCENT_OVERRIDES = {
  peluqueria: "Peluquería",
  peluquerias: "Peluquerías",
  barberia: "Barbería",
  barberias: "Barberías",
  estetica: "Estética",
  consultoria: "Consultoría",
  abogados: "Abogados",
  despacho: "Despacho",
  autoescuela: "Autoescuela",
  pizzeria: "Pizzería",
  pizzerias: "Pizzerías",
};

const capitalizeWord = (w) => {
  if (!w) return "";
  const lower = w.toLowerCase();
  if (ACCENT_OVERRIDES[lower]) return ACCENT_OVERRIDES[lower];
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

export const formatListName = (name) =>
  (name || "")
    .split("_")
    .map(capitalizeWord)
    .join(" ");

// Reemplaza in-place cualquier token con guion bajo en un texto libre
// (p. ej. "20 leads en estetica_ontinyent." → "20 leads en Estética Ontinyent.").
export const formatListNamesInText = (text) =>
  (text || "").replace(
    /[a-záéíóúñ]+(?:_[a-záéíóúñ]+)+/gi,
    (m) => formatListName(m),
  );
